import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import OneSignal from "./components/OneSignal";

import { AuthProvider } from "./providers/auth";
import { ThemeProvider } from "./hooks/useTheme";

import { BrowserRouter as Router } from "react-router-dom";
import "@coreui/coreui/dist/css/coreui.min.css";
import "./index.css";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <ThemeProvider>
            <OneSignal>
              <App />
            </OneSignal>
          </ThemeProvider>
        </AuthProvider>
      </Router>
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />}
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
);